const getDisplayName = (obj: any, defaultName: string = 'System') => {
  if (!obj || !obj.first_name) return defaultName

  return `${obj.first_name} ${obj.last_name || ''}`
}

export default getDisplayName
